angular.module('SpidApp')

.constant('SaleAdapterConfig', {
  name : 'Sale',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'transaction_id',
    	distant : 'transaction_id'
    }, {
  		local   : 'obj_id',
  		distant : 'obj_id'
    }, {
  		local   : 'obj_table_ref',
  		distant : 'obj_table_ref'
  	}, {
  		local   : 'unit',
  		distant : 'unit'
  	}, {
  		local   : 'label',
  		distant : 'label'
  	}, {
  		local   : 'code_tva',
  		distant : 'code_tva'
  	}, {
  		local   : 'price',
  		distant : 'price'
  	}, {
  		local   : 'local_price',
  		distant : 'local_price'
  	}, {
  		local   : 'weight',
  		distant : 'weight'
  	}, {
	    local   : 'updated_at',
	    distant : 'updated_at'
  	}, {
        local   : 'agency_id',
        distant : 'agency_id'
    }, {
        local   : 'label',
        distant : 'label'
    }, {
        local   : 'equinox',
        distant : 'equinox'
    }, {
        local   : 'currency_rate',
        distant : 'currency_rate'
    }, {
        local   : 'code_affranchissement',
        distant : 'code_affranchissement'
    }, {
        local   : 'code_destination',
        distant : 'code_destination'
    }, {
        local   : 'parent',
        distant : 'parent'
    }, {
        local   : 'deno_services',
        distant : 'deno_services'
    }
  ]
})
